import { Text } from '@dixa/lib-shared-habla';
import { ConversationAutomationSideConversationLogEntry } from 'lib-shared-types-api';

import { AppLink } from 'components/appLink';

type RoutedThroughCustomAttributesProps = {
  node: ConversationAutomationSideConversationLogEntry;
};

export function RoutedThroughSideConversation({
  node,
}: RoutedThroughCustomAttributesProps): JSX.Element {
  const postfix = node.csid_created ? (
    <>
      Created side conversation{' '}
      <strong>
        <AppLink
          path="/conversation/:csid"
          params={{ path: { csid: node.csid_created.toString() } }}
        >
          #{node.csid_created}
        </AppLink>
      </strong>
    </>
  ) : (
    'No side conversation created'
  );
  return <Text.Paragraph>Side conversation · {postfix}</Text.Paragraph>;
}
